import { Button, TextField } from '@spiaggeit/spit-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '@/hooks/store'
import { SectorRuleError } from '@/models/http'
import { sectorRulesSlice } from '@/store/sectorRulesSlice'

type Props = {
  onConfirm: (unavailableSectors: number[]) => void
}

export function PreemptionCodeContent(props: Props) {
  const { t } = useTranslation()

  const [preemptionCode, setPreemptionCode] = React.useState('')
  const [preemptionCodeError, setPreemptionCodeError] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)

  const dispatch = useAppDispatch()

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    const adjustedPreemptionCode = preemptionCode.trim()
    setIsLoading(true)

    dispatch(
      sectorRulesSlice.actions.loadUnavailableSectors({
        preemptionCode: adjustedPreemptionCode,
      })
    )
      .unwrap()
      .then((payload) => {
        if (
          payload.errors.find(
            (error) =>
              error.ruleType === 'preemption-code-validation' &&
              error.ruleError === SectorRuleError.INVALID_CODE
          )
        ) {
          setPreemptionCodeError(true)
        } else {
          dispatch(
            sectorRulesSlice.actions.setPreemptionCode(adjustedPreemptionCode)
          )
          props.onConfirm(payload.unavailableSectors)
        }
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <div className="p-4">
      <form onSubmit={handleSubmit}>
        <TextField
          className={preemptionCodeError ? 'mb-2' : null}
          containerClassName="mb-8"
          errorMsg={
            preemptionCodeError
              ? t('preemptionCode.dialog.codeValidationError')
              : null
          }
          id="preemption-code"
          label={t('preemptionCode.dialog.code')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setPreemptionCode(e.target.value)
          }}
          value={preemptionCode}
        />

        <Button
          disabled={preemptionCode.trim().length === 0}
          fullWidth
          isLoading={isLoading}
          type="submit"
        >
          {t('preemptionCode.dialog.submitBtn')}
        </Button>
      </form>
    </div>
  )
}
